import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Cloud: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m462.49 570h-200.76c-38.27 0-73.8-13.47-100.05-37.93-26.88-25.04-41.68-59.52-41.68-97.07 0-32.54 12.19-65.93 33.45-91.61 23.16-27.98 53.9-43.39 86.55-43.39v30c-23.55 0-46.09 11.55-63.45 32.52-16.88 20.39-26.55 46.81-26.55 72.48 0 59.86 48.03 105 111.73 105h200.76c92.37 0 167.51-74.02 167.51-165s-75.15-165-167.51-165c-45.55 0-86.61 16.97-115.62 47.78-30.66 32.57-46.87 78.29-46.87 132.22-16.98 0-30.16-14.79-28.25-31.66 5.46-48.16 23.6-89.6 53.27-121.12 34.74-36.9 83.55-57.22 137.46-57.22 108.91 0 197.51 87.48 197.51 195s-88.6 195-197.51 195z' />
  </IconBase>
));

Cloud.displayName = 'Cloud';

export default Cloud;
